export default __webpack_public_path__ + "static/media/a74ae2bf6bbeddb7f35448341f538c7b.svg";